/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$("[data-chars-remaining]").each(function() {
  const $el = $(this);
  const $target = $($el.data("chars-remaining"));
  const maxChars = parseInt($el.data("maximum-chars"));
  const errorText = $el.data("error-text");

  const fn = function() {
    const chars = maxChars - twttr.txt.getTweetLength($el.val());
    $target.text(chars);
    if (chars < 0) {
      $target.css("color", "red");
      $target.attr("title", errorText);
      return $el.parent().find('button').attr('disabled','disabled');
    } else {
      $el.parent().find('button').removeAttr('disabled');
      $target.attr("title", "");
      return $target.css("color", "#5D5D5D");
    }
  };

  $el.keyup(fn);
  return fn();
});
